import { render, staticRenderFns } from "./campus.vue?vue&type=template&id=0428423d&scoped=true"
import script from "./campus.vue?vue&type=script&lang=js"
export * from "./campus.vue?vue&type=script&lang=js"
import style0 from "./campus.vue?vue&type=style&index=0&id=0428423d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0428423d",
  null
  
)

export default component.exports